/* eslint-disable react-hooks/exhaustive-deps */
import { useNavigate, useParams } from "react-router";
import {
  ControlledInput,
  PrimaryButton,
  SecondaryButton,
} from "../../components";
import { withProtectedRoute } from "../../utils/HOC/withProtectedRoute";
import { useForm } from "react-hook-form";
import { useEffect } from "react";
import { useStatiegeldProducts } from "../../store/useStatiegeldProducts";
import { withAdminPermission } from "../../utils/HOC/withAdminPermission";

type Inputs = {
  name: string;
  gtin: string;
};

function EditStatiegeldProductScreen() {
  /** Params */
  const params = useParams();
  /** Hooks */
  const {
    updateStatiegeldProduct,
    updatedStatiegeldProduct,
    clearUpdatedStatiegeldProduct,
    getStatiegeldProduct,
    statiegeldProduct,
  } = useStatiegeldProducts();
  const navigate = useNavigate();
  const {
    reset,
    control,
    handleSubmit,
    formState: { errors },
  } = useForm<Inputs>();

  /** Effects */
  useEffect(() => {
    if (updatedStatiegeldProduct) {
      clearUpdatedStatiegeldProduct();
      navigate(-1);
    }
  }, [updatedStatiegeldProduct]);

  useEffect(() => {
    getStatiegeldProduct(params?.id as string);
  }, []);

  useEffect(() => {
    if (statiegeldProduct) {
      reset({
        name: statiegeldProduct.name,
        gtin: statiegeldProduct.gtin,
      });
    }
  }, [statiegeldProduct]);

  /** Callbacks */
  const goBack = () => navigate(-1);

  const onSubmit = async (data: Inputs) => {
    updateStatiegeldProduct(params?.id as string, data);
  };

  return (
    <div>
      <div className="flex flex-row items-center mb-6">
        <h1 className="font-satoshi text-2xl font-bold text-dark">
          Edit Statiegeld Product
        </h1>
      </div>
      <div className="flex flex-row">
        <div className="w-full sm:w-1/2 bg-white border border-gray-border drop-shadow-md">
          <div className="w-full border-b border-gray-border px-[28px] py-[15px]">
            <p className="font-satoshi font-medium text-base text-dark">
              Update Statiegeld Product details
            </p>
          </div>
          <form onSubmit={handleSubmit(onSubmit)} className="w-full px-7 py-7">
            <ControlledInput
              control={control}
              error={Boolean(errors?.name)}
              label="Name"
              placeholder="Statiegeld Product name"
              name="name"
              rules={{ required: true }}
            />
            <ControlledInput
              control={control}
              error={Boolean(errors?.gtin)}
              label="GTIN"
              placeholder="Statiegeld product GTIN"
              name="gtin"
              rules={{ required: true }}
            />
            <div className="flex flex-row items-center justify-end">
              <SecondaryButton type="button" onClick={goBack} label="Cancel" />
              <PrimaryButton type="submit" className="ml-4" label="Save" />
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default withProtectedRoute(
  withAdminPermission(EditStatiegeldProductScreen)
);
